import * as React from 'react';
import { Route, Routes } from 'react-router-dom';

import { Deployment } from 'components/deployment/Deployment';
import { PageNotFound } from 'components/common/PageNotFound';
import { EnvironmentCheck } from 'components/environmentcheck/EnvironmentCheck';

export const AppRoutes = () => (
	<Routes>
		<Route path='*' element={<PageNotFound />} />
		<Route path='/' element={<Deployment />}/>
		<Route path='/environmentcheck' element={<EnvironmentCheck />}/>
	</Routes>
);
